import '../list/gb-list.tag.html';
import '../product/gb-product.tag.html';
import { Results } from './gb-results';
riot.tag2('gb-results', '<yield> <gb-list items="{records}"> <gb-product all_meta="{item.allMeta}"></gb-product> </gb-list> </yield>', 'gb-results .gb-stylish gb-list,[riot-tag="gb-results"] .gb-stylish gb-list,[data-is="gb-results"] .gb-stylish gb-list{ padding: 0; list-style: none; display: flex; flex-wrap: wrap; justify-content: space-around; } gb-results .gb-stylish gb-product,[riot-tag="gb-results"] .gb-stylish gb-product,[data-is="gb-results"] .gb-stylish gb-product{ display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; }', '', function(opts) {
    this._mixin(Results);
});



/** WEBPACK FOOTER **
 ** ./src/tags/results/gb-results.tag.html
 **/